<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="settlementsLoadStatus===1 || settlementAddStatus===1 || settlementEditStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
            dense
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Rozliczenia</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Rok" v-model="selectedYear"  class="choose_year" :items="calendarYears" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Miesiąc" v-model="selectedMonth"  class="choose_month" :items="lookups.months" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select clearable  :disabled="selectedChild>0" label="Grupa" v-model="selectedCourse"  class="choose_year" :items="lookups.courses" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <children-live-search  :disabled="selectedCourse>0" clearable :selectedChild="selectedChild" @childSelected="selectedChild=$event" />

                  <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select label="Status"  clearable v-model="selectedStatus"  class="choose_status" :items="lookups.settlementsStatus" hide-details ></v-select>

                <!-- <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchSettlements"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip> -->


                <v-spacer></v-spacer>

                <v-dialog v-if="user.permissions['settlement'] >= 10" v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="settlementEditLoadStatus===1 || settlementAddStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                          <v-row>
                            <v-col  cols="12" sm="2" md="2"><h3 class="pt-5">Okres:</h3></v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-select @change="radioChange" label="Rok" v-model="editedItem.selectedYear"  :items="calendarYears" hide-details ></v-select>
                            </v-col> 
                              <v-col cols="12" sm="1" md="1"></v-col>
                             <v-col cols="12" sm="4" md="4">
                              <v-select @change="radioChange" label="Miesiąc" v-model="editedItem.selectedMonth"  :items="lookups.months" hide-details ></v-select>
                            </v-col> 
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="2" md="2">
                              <h3 class="pt-5">Zakres:</h3>
                            </v-col> 
                             <v-col cols="12" sm="10" md="10">
                              <v-radio-group @change="radioChange" row v-model="editedItem.range">
                                <v-radio label="Wszystkie grupy" value="all"></v-radio><v-radio   label="Wybrane grupy" value="course"></v-radio>
                                <v-radio label="Wybrane dzieci" value="child"></v-radio>
                              </v-radio-group>
                            </v-col> 
                          </v-row>
                          <v-row v-if="editedItem.range==='child'">                     
                             <v-col cols="12" sm="10" md="10">
                               <v-autocomplete
                                  v-model="selectedReference"
                                  :loading="childrenLookupLoadStatus==1"
                                  :items="childrenLookup"
                                  :search-input.sync="searchReference"
                                  class="mx-4 search"
                                  style="max-width: 300px;"
                                  flat
                                  hide-no-data
                                  hide-details
                                  label="Wyszukaj dziecko"
                                ></v-autocomplete>
                            </v-col> 
                          </v-row>
                          <v-row  v-if="editedItem.range==='child'">                     
                             <v-col cols="12" sm="12" md="12">
                               <v-simple-table dense>
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th>Imię nazwisko</th>
                                        <th>Aktualna grupa</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="c in editedItem.children" :key="c.value">
                                        <td>{{c.text}}</td>
                                        <td>{{c.course}}</td>
                                        <td>
                                          <v-icon
                                              size="20"
                                              class=""
                                              @click="selectedChildrenRemove(c)"
                                            >
                                              mdi-close-outline
                                            </v-icon>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                            </v-col> 
                          </v-row>
                          <v-row  v-if="editedItem.range==='course'">                     
                             <v-col cols="12" sm="12" md="12">
                               <v-data-table
                                  v-model="editedItem.selectedCourses"
                                  :headers="headersCourses"
                                  :items="editedItem.courses"
                                  item-key="id"
                                  show-select
                                  hide-default-footer
                                  disable-pagination
                                  dense
                                >

                                <template v-slot:header.data-table-select>
                                  
                                </template>

                                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                <v-simple-checkbox
                                  v-if="item.children_with_settlement!=item.children_with_history_count"
                                  class="v-data-table__checkbox"
                                  :value="isSelected"
                                  @input="select"
                                ></v-simple-checkbox>
                              </template>

                                <template v-slot:item.status="{ item }">
                                  {{item.children_with_settlement}}/{{item.children_with_history_count}}
                                </template>

                                </v-data-table>
                            </v-col> 
                          </v-row>
                          <v-row v-if="settlementAddStatus===2">
                                    <v-col class="d-flex flex-column align-center">
                                        <v-alert v-if="settlementAddText.successCount>0" dense outlined type="success">
                                          Liczba poprawnych rozliczeń: <b>{{settlementAddText.successCount}}</b>
                                        </v-alert>
                                        <v-alert v-if="settlementAddText.errorCount>0" dense outlined type="error">
                                          Liczba błędnych rozliczeń: <b>{{settlementAddText.errorCount}}</b>
                                        </v-alert>    

                                    </v-col>
                            </v-row>   
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn v-if="settlementAddStatus===2" color="gray" text @click="close">Zamknij</v-btn>
                      <v-btn v-if="settlementAddStatus!==2" color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn v-if="settlementAddStatus!==2" :disabled="(editedItem.range=='child' && editedItem.children.length==0) || (editedItem.range=='course' && editedItem.selectedCourses.length==0)" color="primary darken-1" text @click="handleSubmit" >Generuj</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialogLog" >
                <v-card class="pl-1 pr-1" :loading="settlementEditLoadStatus===1">
                  <v-data-table
                    :headers="headersLog"
                    :items="editedItem.log"
                    class="elevation-0"
                    dense
                    hide-default-footer
                    disable-pagination
                    disable-sort
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white" dense>
                        <v-toolbar-title>Szczegóły rozliczenia</v-toolbar-title>
                    
                        <v-spacer></v-spacer>

                        <v-btn  @click="dialogLog = false" outlined class="mb-2 mt-2"  color="primary">
                          <v-icon>mdi-close-thick</v-icon>
                        </v-btn>
                        
                      </v-toolbar>
                    </template>


                    <template  v-slot:item.error="{ item }">
                      <!-- <v-icon v-if="item.error" size="18" color="error">mdi-exclamation-thick</v-icon> -->
                      
                      <v-btn  @click="editPresenceItem(item)" v-if="item.error" x-small  color="error">
                          Popraw
                      </v-btn>
                    </template>


                    <template  v-slot:item.present="{ item }">
                      <v-simple-checkbox v-if="item.present!=null"  v-model="item.present" disabled></v-simple-checkbox>
                      <span  v-if="item.present==null" size="18" class="rateerror">Brak danych</span>
                    </template>
                    <template  v-slot:item.actual="{ item }">
                      <v-simple-checkbox class="float-left" v-if="item.actual!=null" v-model="item.actual" disabled></v-simple-checkbox>
                      <!-- <v-icon v-if="!item.actual" size="18" color="error">mdi-exclamation-thick</v-icon> -->
                    </template>

                    <template  v-slot:item.enter="{ item }">
                      {{item.enter}}
                      <span  v-if="item.present && !item.enter" size="18" class="rateerror">Brak danych</span>
                    </template>

                    <template  v-slot:item.leave="{ item }">
                      {{item.leave}}
                      <span  v-if="item.present && !item.leave" size="18" class="rateerror">Brak danych</span>
                    </template>
                    <template  v-slot:item.tolerance="{ item }">
                      {{item.tolerance>0?item.tolerance+' min':''}}
                      
                    </template>

                     <template  v-slot:item.course="{ item }">
                      {{item.course}}
                      <span  v-if="item.course==null" size="18" class="rateerror">Brak cennika</span>
                    </template>

                    <template  v-slot:item.rate="{ item }">
                      {{item.rate}}
                      <span  v-if="item.rate==null" size="18" class="rateerror">Brak cennika</span>
                    </template>

                    <template  v-slot:item.hour="{ item }">
                      <template v-if="!isNaN(item.hour)">{{ $n(item.hour, 'currency', 'pl-PL') }}</template>
                    </template>

                    <template  v-slot:item.overtime="{ item }">
                      <template v-if="!isNaN(item.overtime)">{{ $n(item.overtime, 'currency', 'pl-PL') }}</template>
                    </template>

                    <template  v-slot:item.meal="{ item }">
                      <template v-if="!isNaN(item.meal)">{{ $n(item.meal, 'currency', 'pl-PL') }}</template>
                    </template>

                    <template  v-slot:item.other="{ item }">
                      <template v-if="!isNaN(item.other)">{{ $n(item.other, 'currency', 'pl-PL') }}</template>
                    </template>

                    <template  v-slot:item.sum="{ item }">
                      <template><b>{{ $n(item.sum, 'currency', 'pl-PL') }}</b></template>
                    </template>

                    
                    
                  </v-data-table> 
                </v-card>          
              </v-dialog>  
              <v-dialog  v-model="dialogBO" max-width="500px">
                  <settlement-bo-editor :child-id="childId" @close="closeBOEditor" ></settlement-bo-editor>
             </v-dialog>
             <v-dialog v-if="user.permissions['journal'] >= 5" v-model="dialogPresence" max-width="700px">
                  <presence-editor @close="closePresence" :item-editing="true" />
              </v-dialog>
              </v-toolbar>
            </template>


            <template v-slot:item.actions="{ item }">

                

             <v-btn @click="loadSettlementLog(item)" v-if="item.settlements && user.permissions['settlement'] >= 5" class="mr-1"  color="primary" x-small>Detale</v-btn>
             
             <v-btn @click="childId=item.id;dialogBO=true" v-if="item.settlements_count==0 && user.permissions['settlement'] >= 5" color="primary" class="mr-1" x-small>BO</v-btn>
              
              <v-tooltip v-if="item.settlements && item.settlements.can_delete && user.permissions['settlement'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

            </template> 

            <template  v-slot:item.present="{ item }">
              <template v-if="item.settlements">{{ item.settlements.present===1?item.settlements.present+' dzień':item.settlements.present+' dni' }}</template>
            </template>

            <template  v-slot:item.absent="{ item }">
              <template v-if="item.settlements">{{ item.settlements.absent===1?item.settlements.absent+' dzień':item.settlements.absent+' dni' }}</template>
            </template>

            <template  v-slot:item.fix="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'">{{$n(item.settlements.fix, 'currency', 'pl-PL')}}{{ item.settlements.fix_meal?'/'+$n(item.settlements.fix_meal, 'currency', 'pl-PL'):'' }}{{ item.settlements.fix_other?'/'+$n(item.settlements.fix_other, 'currency', 'pl-PL'):'' }}</template>
            </template>

             <template  v-slot:item.hour="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'">{{ $n(item.settlements.hour, 'currency', 'pl-PL') }}</template>
            </template>

            <template  v-slot:item.overtime="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'">{{ $n(item.settlements.overtime, 'currency', 'pl-PL') }}</template>
            </template>

            <template  v-slot:item.meal="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'">{{ $n(item.settlements.meal, 'currency', 'pl-PL') }}</template>
            </template>

            <template  v-slot:item.other="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'">{{ $n(item.settlements.other, 'currency', 'pl-PL') }}</template>
            </template>

            <template  v-slot:item.sum="{ item }">
              <template v-if="item.settlements && item.settlements.status!=='Błąd'"><b>{{ $n(item.settlements.amount, 'currency', 'pl-PL') }}</b></template>
            </template>

            <template v-slot:item.courses="{ item }">
              <div v-html='item.courses'/>
            </template>

            <template v-slot:item.rates="{ item }">
              <div v-html='item.rates'/>
              <span  v-if="!item.rates" size="18" class="rateerror"><v-icon size="18" color="error">mdi-exclamation-thick</v-icon>Brak cennika</span>
            </template>

            <template v-slot:item.status="{ item }">
              {{ item.settlements?item.settlements.status:'Brak' }}
            </template>

             <template  v-slot:item.notifications="{ item }">
                <template>
                  <v-tooltip right v-if="item.settlements">
                    <template v-slot:activator="{ on }">
                      <v-icon @click="sendNotification(item.settlements)"  v-on="on" size="24" :color="item.settlements.notification_status===5?'green darken-3':(item.settlements.notification_status>=10?'red darken-3':'grey')">mdi-email-fast-outline</v-icon>
                    </template>
                      <span v-if="item.settlements.notification_status===0">Brak powiadomienia. Kliknij aby wysłać.</span>
                      <span v-if="item.settlements.notification_status===5">Wysłano {{item.settlements.notification_date}} do {{item.settlements.notification_recipient}}</span>
                      <span v-if="item.settlements.notification_status >= 10">{{_.find(lookups.notifications_status,{'value':item.settlements.notification_status}).text }}. Kliknij aby ponowić próbę.</span>
                  </v-tooltip>  
                </template>
             </template>

                  <template slot="body.append">
                      <tr class="v-data-table__selected font-weight-medium subheading">
                              <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                              <td>Suma</td>
                              <td>{{ $n(sumField('fix'), 'currency', 'pl-PL') }}/{{ $n(sumField('fix_meal'), 'currency', 'pl-PL') }}</td>
                              <td>{{ $n(sumField('hour'), 'currency', 'pl-PL') }}</td>
                              <td>{{ $n(sumField('overtime'), 'currency', 'pl-PL') }}</td>
                              <td>{{ $n(sumField('meal'), 'currency', 'pl-PL') }}</td>
                              <td>{{ $n(sumField('other'), 'currency', 'pl-PL') }}</td>
                              <td>{{ $n(sumField('amount'), 'currency', 'pl-PL') }}</td>
                              <td></td>
                              <td></td>
                              <!-- <td>{{ sumField('lunch')}}</td>
                              <td>{{ sumField('tea')}}</td>
                              <td>{{ sumField('diet')}}</td> -->
                      </tr>
                  </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && settlementsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
              <v-btn @click="loadSettlements" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadSettlements" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>
          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import Vue from 'vue'
  import confirm from '../components/Confirm'
  import settlementBoEditor from '../components/SettlementBOEditor'
  import ChildrenLiveSearch from '../components/ChildrenLiveSearch'
  import PresenceEditor from '../components/PresenceEditor'
  
  export default {
    components:{
      confirm,
      settlementBoEditor,
      ChildrenLiveSearch,
      PresenceEditor
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      dialogLog:false,
      dialogBO:false,
      dialogPresence:false,
      childId:45,
      settlementId:null,
      search:'',
      selectedReference:'',
      searchReference: null,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        // { text: 'Miesiąc', value: 'month',filterable:true,filterColumn:"month" },
        // { text: 'Rok', value: 'year',filterable:true,filterColumn:"year" },
        { text: '', value: 'notifications', sortable: false,filterable:false },
        { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"surname" },
        { text: 'Imię', value: 'name',filterable:true,filterColumn:"name" },
        { text: 'Cenniki', value: 'rates',filterable:true,sortable: false,filterColumn:"ratesWithHistory.name"},
        { text: 'Grupy', value: 'courses',filterable:true,sortable: false,filterColumn:"coursesWithHistory.name"},
        { text: 'Obecne', value: 'present',filterable:true,sortable: false,filterColumn:"settlements.present"  },
        { text: 'Nieobecne', value: 'absent',filterable:true,sortable: false,filterColumn:"settlements.absent"  },
        { text: 'Stałe', value: 'fix',filterable:true,sortable: false,filterColumn:"settlements.fix"  },
        { text: 'Pobyt', value: 'hour',filterable:true,sortable: false,filterColumn:"settlements.hour"  },
        { text: 'Nadgodziny', value: 'overtime',filterable:true,sortable: false,filterColumn:"settlements.overtime"  },
        { text: 'Wyżywienie', value: 'meal',filterable:true,sortable: false,filterColumn:"settlements.meal"  },
        { text: 'Inne', value: 'other',filterable:true,sortable: false,filterColumn:"settlements.other"  },
        { text: 'Suma', value: 'sum',filterable:false,sortable: false  },
        { text: 'Status', value: 'status',filterable:true,sortable: false,filterColumn:"settlements.status"  },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false },
      ],
       headersCourses: [
        { text: 'Grupa', value: 'name',sortable: false},
        { text: 'Placówka', value: 'department.name',sortable: false },
        { text: 'Stan', value: 'status',sortable: false },
      ],
       headersLog: [
        {text:'', value: 'error'},
        { text: 'Data', value: 'day'},
        { text: 'Obecne', value: 'present' },
        { text: 'Wejście', value: 'entry'},
        { text: 'Wyjście', value: 'leave'},
        { text: 'Darmowe', value: 'free'},
        { text: 'Tolerancja', value: 'tolerance'},
        { text: 'Grupa', value: 'course' },
        { text: 'Cennik', value: 'rate'  },
        { text: 'Aktualny', value: 'actual'},
        { text: 'Pobyt', value: 'hour'},
        { text: 'Nadgodziny', value: 'overtime'},
        { text: 'Wyżywienie', value: 'meal' },
        { text: 'Inne', value: 'other' },
        { text: 'Suma', value: 'sum' },
      ],
    }),
    validations: {
      editedItem:{
       
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = _.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
      dialogBO (val) {
        val || this.closeBOEditor()
      },
      dialog (val) {
        this.$v.$reset()
        if(val){
          this.editedItem.selectedYear = this.options.selectedYear;
          this.editedItem.selectedMonth = this.options.selectedMonth;
        }
        val || this.close();
      },
      dialogPresence (val) {
        val || this.closePresence()
      },
      presenceEditStatus(val){
        if(val===2){
          this.closePresence();
          //przeliczanie rozliczenia
          this.$store.dispatch( 'loadSettlementRecalculate', {slug:this.settlementId} )
        }
      },
      settlementDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      selectedReference(val){
        if(val){
          //jeżeli nie ma jeszcze tego dziecka
          if(!Vue._.find(this.editedItem.children,{'value':val})){
            this.editedItem.children.push(Vue._.find(this.childrenLookup,{'value':val}));
          }
          this.$nextTick(() => {
            this.selectedReference = null;
          })
        }
      },
      searchReference (val) {
        val && val !== this.selectedReference && val.length>2 && this.querySelectionsReference(val)
      },
    },
    computed: {
      calendarYears(){
        var calYears = [];
        this.lookups.years.forEach(year => {
          if(!Vue._.find(calYears,{value:year.year_from}))calYears.push({value:year.year_from,text:year.year_from.toString()});
          if(!Vue._.find(calYears,{value:year.year_to}))calYears.push({value:year.year_to,text:year.year_to.toString()});
        });
        return calYears;
      },
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getSettlementOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setSettlementOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          currentOptions.selectedCourse = 0;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedYear} );
        }
      },
      selectedMonth:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedMonth;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedMonth = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      selectedCourse:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedCourse;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedCourse = value;
          this.options = currentOptions;
        }
      },
      selectedChild:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedChild;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedChild = value;
          this.options = currentOptions;
        }
      },  
      selectedStatus:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedStatus;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedStatus = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },

      selectedDay:{
        get () {
          return this.$store.getters.getSettlementOptions.selectedDay;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedDay = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
     
      editedItem(){
        return this.$store.getters.getSettlementEdit;
      },
      tableItems(){
        return this.$store.getters.getSettlements;
      },
      settlementsLoadStatus(){
        return this.$store.getters.getSettlementsLoadStatus;
      },
      settlementAddStatus(){
        return this.$store.getters.getSettlementAddStatus();
      },
      settlementAddText(){
        return this.$store.getters.getSettlementAddText;
      },
      settlementEditLoadStatus(){
        return this.$store.getters.getSettlementEditLoadStatus
      },
      settlementEditStatus(){
        return this.$store.getters.getSettlementEditStatus();
      },
      settlementEditText(){
        return this.$store.getters.getSettlementEditText
      },
      settlementDeleteStatus(){
        return this.$store.getters.getSettlementDeleteStatus();
      },
      presenceEditStatus(){
        return this.$store.getters.getPresenceEditStatus();
      },
      childrenLookupLoadStatus(){
        return this.$store.getters.getChildrenLookupLoadStatus;
      },
      childrenLookup(){
        return this.$store.getters.getChildrenLookup;
      },
      computedHeaders () {
        if(this.user.permissions['settlement'] < 5) return this.headers.filter(h => h.value!=='actions')
        else return this.headers
      },
      formTitle () {
        return 'Generowanie rozliczenia';
      },
      
      // nameErrors () {
      //   const errors = []
      //   if (!this.$v.editedItem.name.$dirty) return errors
      //   !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
      //   !this.$v.editedItem.name.maxLength && errors.push('Nazwa może mieć maksymalnie 20 znaków')
      //   return errors
      // },
    },
    mounted(){

      if(this.lookups.years.length>0){
        this.loadSettlements();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadSettlements();
        }, 2000)
      }
    },
    methods: {
      sendNotification(settlement){
        if(settlement.notification_status===5){
          this.$refs.confirm.open('Potwierdź', 'Czy na pewno chcesz ponownie wysłać powiadomienie?', { color: 'warning' }).then((confirm) => {
              if(confirm){
                this.$store.dispatch( 'sendSettlementsNotificaiton', {slug:  settlement.id}); 
              }
          })
        }else{
          this.$store.dispatch( 'sendSettlementsNotificaiton', {slug:  settlement.id}); 
        }
      },
      editPresenceItem (item) {
        this.$store.dispatch( 'loadPresenceEditById', {slug:  this.childId, selectedDay:item.day});  
        this.dialogPresence = true;
      },
      loadSettlements(){
        this.search='';
        var currentOptions = {...this.$store.getters.getSettlementOptions};
        var date = new Date(); 
        //currentOptions.selectedDay = date.toISOString().substr(0,10);
        currentOptions.selectedYear = parseInt(date.toISOString().substr(0,4));
        currentOptions.selectedMonth = parseInt(date.toISOString().substr(6,2));
        this.$store.dispatch( 'setSettlementOptions', {options:currentOptions} )
      },
      loadSettlementLog(s){
        this.dialogLog = true;
        this.childId = s.id;
        this.settlementId = s.settlements.id;
        this.$store.dispatch( 'loadSettlementLog', {slug:s.settlements.id} )
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreSettlements' );
      },
      querySelectionsReference (v) {
        this.$store.dispatch( 'searchChildrenSettlementLookup',{q:v,selectedYear:this.editedItem.selectedYear,selectedMonth:this.editedItem.selectedMonth}); 
      },
      searchSettlements(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchSettlements',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
      selectedChildrenRemove(child){
        const index = this.editedItem.children.indexOf(child)
        this.editedItem.children.splice(index, 1)
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać rozliczenie na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteSettlement', {slug:  item.settlements.id});
            }
        })
      },
      radioChange(val){
        this.editedItem.children = [];
        this.editedItem.courses = [];
        if(val && this.editedItem.range==='course'){
          this.$store.dispatch( 'loadSettlementsInCourse',{selectedYear:this.editedItem.selectedYear,selectedMonth:this.editedItem.selectedMonth}); 
        }
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadSettlementEditDefault'); 
          //this.itemEditing = false
        }, 300)
      },
      closeBOEditor(){
        this.dialogBO = false;
      },
      sumField(key) {
        return this.tableItems.reduce((a, b) => a + ((b.settlements &&  b.settlements[key])?b.settlements[key]:0 || 0), 0);
      },
      closePresence() {
        this.dialogPresence = false
        setTimeout(() => {
          this.$store.dispatch( 'loadPresenceEditDefault'); 
          this.$store.dispatch( 'loadPresenceAddDefault');
        }, 300)
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
              var ids = [];
              if(this.editedItem.range=='child'){
                ids = Vue._.map(this.editedItem.children,'value');
              }else if(this.editedItem.range=='course'){
                ids = Vue._.map(this.editedItem.selectedCourses,'id');
              }

              this.$store.dispatch( 'generateSettlements', {
                range: this.editedItem.range,
                year: this.editedItem.selectedYear,
                month: this.editedItem.selectedMonth,
                ids:ids,
              });
          
        }
      },
    },
  }
</script>


<style scoped>
span.rateerror{
  color:red;
}
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 100px;
}

.choose_month{
      max-width: 150px;
}

.choose_status{
      max-width: 200px;
}

.choose_date{
      max-width: 150px;
}
</style>